import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { loadConsents, saveConsents } from "../../actionCreators";
import { getConsents } from "../../selectors";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ConsentComponent from "./ConsentComponent";

const ConsentContainer = ({ consents, consentsLoaded, partnerId, actions, setIsDirty, hasWritePermission }) => {
  const [localConsents, setLocalConsentList] = useState(consents);
  const [consentCardExpanded, setConsentCardExpanded] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(true);

  const saveConsents = (partnerId, localConsents) => {
    if (!hasWritePermission) return;
    actions.saveConsents(partnerId, localConsents, () => {
      setConsentCardExpanded(false);
      setIsDirty(false);
    });
    setSaveDisabled(true);
  };

  const onConsentCardExpanded = expanded => {
    if (consentCardExpanded !== expanded) setConsentCardExpanded(expanded);
  };

  useEffect(() => {
    if (!(consentsLoaded && consentCardExpanded) && partnerId !== null) {
      actions.loadConsents(partnerId);
    }
  }, [consentsLoaded]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (consentsLoaded) {
      setLocalConsentList(consents);
    }
  }, [consentsLoaded]); // eslint-disable-line react-hooks/exhaustive-deps

  const onConsentPropertyChange = idx => prop => value => {
    setLocalConsentList(
      Object.assign([], {
        ...localConsents,
        [idx]: {
          ...localConsents[idx],
          [prop]: value
        }
      })
    );
    setSaveDisabled(false);
    setIsDirty(true);
  };

  return (
    <ConsentComponent
      consents={localConsents}
      saveConsents={saveConsents}
      partnerId={partnerId}
      consentCardExpanded={consentCardExpanded}
      onConsentCardExpanded={onConsentCardExpanded}
      onConsentPropertyChange={onConsentPropertyChange}
      hasWritePermission={hasWritePermission}
      saveDisabled={saveDisabled}
    />
  );
};

ConsentContainer.propTypes = {
  consents: PropTypes.array,
  consentsLoaded: PropTypes.bool.isRequired,
  consentsLoading: PropTypes.bool.isRequired,
  partnerId: PropTypes.number.isRequired,
  actions: PropTypes.object.isRequired,
  setIsDirty: PropTypes.func,
  hasWritePermission: PropTypes.bool.isRequired
};

function mapStateToProps(state, ownProps) {
  const { content: consents, loaded: consentsLoaded, loading: consentsLoading } = getConsents(
    state,
    ownProps.partnerId
  );

  return {
    consents,
    consentsLoaded,
    consentsLoading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        loadConsents,
        saveConsents
      },
      dispatch
    ),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsentContainer);
